module.exports = __webpack_public_path__ + "img/posture_perfect3.edb3f30b.png";